import Vue from 'vue'
import store from '../store/store'

Vue.directive('can', {
  bind (el, binding) {
    if (
      store.getters.isAuth &&
      store.getters.isAuthUserCompany &&
      !store.getters.authUserCompany.permissions.includes(binding.value)
    ) {
      el.innerHTML = ''
      el.style.display = 'none'
    }
  }
})
